import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let iconOnly = useDataValue({
    context: 'task_boards_list',
    path: 'iconOnly',
    viewPath: props.viewPath,
  })

  let showPrivateIcon = useDataValue({
    context: 'task_boards_list',
    path: 'showPrivateIcon',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    if (!data) return data

    return data.map(item => ({
      ...item,
      new_tasks_count: item.stages?.[0]?.tasks_aggregate?.aggregate?.count || 0,
      iconOnly,
      showPrivateIcon,
    }))
  }, [data, iconOnly, showPrivateIcon])
}
